export default __webpack_public_path__ + "static/wamo-high-five-4cc4a4882148c6a0e213227902c8b58a.jpg";